import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';
import { useAudienceTray } from '../providers/audience-tray-provider';

export const ListsEmptyState = () => {
  const { t } = useTranslation('bulk-messaging');
  const { setMode, trackingIdPrefix } = useAudienceTray();

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: `calc(100% - ${theme.spacing(9)})`,
        padding: theme.spacing(0, 4),
        rowGap: theme.spacing(2),
      }}
    >
      <Text color='subdued' weight='bold'>
        {t('No Saved Lists')}
      </Text>
      <Text color='subdued' css={{ textAlign: 'center' }}>
        {t('Target a group of contacts from an uploaded csv.')}
      </Text>
      <Button
        css={{ display: 'flex', columnGap: theme.spacing(0.5), marginTop: theme.spacing(1) }}
        iconName='plus'
        onClick={() => setMode('upload')}
        trackingId={`${trackingIdPrefix}-contacts-empty-screen-upload-csv-btn`}
        variant='tertiary'
      >
        <Text color='primary'>{t('Upload List')}</Text>
      </Button>
    </div>
  );
};
